import React from 'react'
import ViewIndividualMemberList from '../../../features/gmap/viewIndividualMembers/ViewIndividualMemberList'

export default function ViewIndividualMembers() {
  return (
    <ViewIndividualMemberList />
  )
}